<template>
  <v-dialog v-model="dialog" max-width="500px" persistent>
    <v-card>
      <v-card-title>
        <span class="text-body-1 primary--text">Editar Actividad</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <validation-alert :validationErrors="validationErrors" />
          <v-form ref="form" v-model="isValidFormDialog" lazy-validation>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="editedItem.app_id"
                  v-on:change="listenApplication"
                  :items="applications"
                  :rules="applicationRules"
                  item-text="name"
                  item-value="id"
                  label="Aplicación"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="editedItem.module_id"
                  v-on:change="listenModule"
                  :items="modules"
                  :rules="moduleRules"
                  v-if="editedItem.app_id"
                  item-text="name"
                  item-value="id"
                  label="Módulo"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-select
                  v-model="editedItem.page_id"
                  :items="pages"
                  :rules="pageRules"
                  v-if="editedItem.module_id"
                  item-text="name"
                  item-value="id"
                  label="Paginas"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="editedItem.name"
                  :rules="nameRules"
                  label="Nombre"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-textarea
                  v-model="editedItem.description"
                  name="description"
                  label="Descripción"
                  :rules="descriptionRules"
                ></v-textarea>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-switch v-model="editedItem.active" label="Estado"></v-switch>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close()"> Cancelar </v-btn>
        <v-btn
          color="blue darken-1"
          :loading="isLoading"
          :disabled="isLoading"
          @click="save()"
          text
        >
          Guardar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ValidationAlert from "@/components/global/ValidationAlert.vue";
import { $EventBus } from "@/main";
export default {
  name: "EditActivityDialog",

  props: {
    activity: Object,
  },

  data: () => ({
    dialog: false,
    isValidFormDialog: false,
    isLoading: false,
    applicationRules: [(v) => !!v || "Campo requerido"],
    moduleRules: [(v) => !!v || "Campo requerido"],
    pageRules: [(v) => !!v || "Campo requerido"],
    nameRules: [(v) => !!v || "Campo requerido"],
    descriptionRules: [(v) => !!v || "Campo requerido"],
    editedItem: {
      app_id: "",
      module_id: "",
      page_id: "",
      name: "",
      description: "",
      active: true,
    },
    defaultItem: {
      app_id: "",
      module_id: "",
      page_id: "",
      name: "",
      description: "",
      active: true,
    },
  }),

  computed: {
    applications() {
      return this.$store.getters["applications/getApplicationsList"];
    },
    modules() {
      return this.$store.getters["modules/getModulesList"];
    },
    pages() {
      return this.$store.getters["pages/getPagesList"];
    },
    validationErrors() {
      return this.$store.getters["activities/getValidationErrors"];
    },
  },

  watch: {
    activity(val) {
      if (val && val.id) {
        this.dialog = true;
        this.editedItem = val;
        this.$store.dispatch("modules/getModulesList", {
          app_id: this.editedItem.app_id,
        });
        this.$store.dispatch("pages/getPagesList", {
          module_id: this.editedItem.module_id,
        });
      }
    },
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.$store.dispatch("activities/cleanValidationErrors");
        this.$refs.form.resetValidation();
      });
    },

    showSnack(color = "", text = "") {
      $EventBus.$emit("showSnack", { color, text });
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        try {
          await this.$store.dispatch(
            "activities/updateActivity",
            this.editedItem
          );
          this.showSnack("green", "Actividad actualizada");
          this.$emit('resetFilter');
          this.close();
        } catch (error) {}
        this.isLoading = false;
      }
    },
    listenApplication() {
      this.editedItem.module_id = null;
      this.editedItem.page_id = null;
      this.$store.dispatch("modules/getModulesList", {
        app_id: this.editedItem.app_id,
      });
    },
    listenModule() {
      this.editedItem.page_id = null;
      this.$store.dispatch("pages/getPagesList", {
        module_id: this.editedItem.module_id,
      });
    },
  },
  components: {
    ValidationAlert,
  },
};
</script>
